import { render } from "./EventsGrid.vue?vue&type=template&id=085ecf78"
import script from "./EventsGrid.vue?vue&type=script&lang=js"
export * from "./EventsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__